import { render } from "./ControlIsland.vue?vue&type=template&id=27899b63&scoped=true"
import script from "./ControlIsland.vue?vue&type=script&lang=js"
export * from "./ControlIsland.vue?vue&type=script&lang=js"

import "./ControlIsland.vue?vue&type=style&index=0&id=27899b63&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.22_vue@3.5.22_webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27899b63"]])

export default __exports__